<header class="flex header">
  <h2>{{ 'SupplyRequest.Detail.CreateRequisition' | translateWF: 'Create Requisition' }}</h2>
  <p-button icon="pi pi-times" (click)="onClose()" [disabled]="isLoading" />
</header>

@if (isLoading) {
  <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
}

<section class="content">
  <p-card>
    <form [formGroup]="mainForm">
      <div class="grid-auto-2">
        <div class="form-box">
          <label>{{ 'SupplyRequest.Detail.RequisitionType' | translateWF: 'Requisition Type' }}</label>
          <p-select class="w-full" [options]="_setOptionsForPrimeNg(externalRequisitionTypeOptions)" formControlName="requisitionType" />
        </div>
        <div class="form-box">
          <label>{{ 'SupplyRequest.Detail.Priority' | translateWF: 'Priority' }}</label>
          <p-select class="w-full" [options]="_setOptionsForPrimeNg(externalRequisitionPriorityOptions)" formControlName="priority" />
        </div>
      </div>
    </form>
  </p-card>

  <p-panel [header]="'SupplyRequest.Detail.RequestedItems' | translateWF: 'Requested Items'">
    <p-card data-variant="compact">
      <p-table [value]="requestedItemsTableData">
        <ng-template #header>
          <tr>
            <th>{{ 'SupplyRequest.Detail.ItemID' | translateWF: 'Item ID' }}</th>
            <th>{{ 'SupplyRequest.Detail.ItemName' | translateWF: 'Item Name' }}</th>
            <th>{{ 'SupplyRequest.Detail.QuantityRequisition' | translateWF: 'Quantity for Requisition' }}</th>
          </tr>
        </ng-template>

        <ng-template #body let-control let-i="rowIndex">
          <tr>
            <td>
              {{ control.itemCode }}
            </td>
            <td>
              {{ localHelperService.getLocalizedValue(control.itemDisplayName) }}
            </td>
            <td>
              <input pInputText type="number" [value]="control.quantityForRequisition" disabled />
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </p-panel>
</section>

<footer>
  <p-button type="submit" class="w-full" [label]="'Common_Confirm' | translateWF: 'Confirm'" (click)="onSave()" [disabled]="!canSave()" />
  <p-button class="w-full" [label]="'Common_Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onClose()" />
</footer>
